import {Component, Injector, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {
    ArticleDto,
    BasketArticleDto,
    CategoryDto,
    IBasketArticleDto,
    OrderGuideSimpleDto,
    PagedResultDtoOfArticleDto,
    PagedResultDtoOfCategoryDto,
    WebShopServiceProxy
} from '@shared/service-proxies/service-proxies';
import {AppComponentBase} from '@shared/common/app-component-base';

import {Subscription, throwError} from 'rxjs';

import {appModuleAnimation, PrimengTableHelper} from '@axilla/axilla-shared';
import _ from 'lodash';
import {finalize, take} from 'rxjs/operators';

import {LazyLoadEvent, SelectItem} from 'primeng/api';

import {WebshopService} from '@app/shared/common/shop-system/services/webshop.service';
import {AppConsts} from '@shared/AppConsts';
import {WebshopItemDetailsModalComponent} from '@app/webshop/shop/webshop-item-details-modal.component';
import {CombineViewService} from '@app/webshop/shared/services/combine-view.service';

@Component({
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class IhscDashboardComponent extends AppComponentBase implements OnInit {

    hideSearch = true;
    categories: CategoryDto[] = [];
    filter = '';
    changeRouter$: Subscription;
    products: BasketArticleDto[];
    isLoadingArticles: boolean;
    isLoadingCategories: boolean;
    sortOptions: SelectItem[];
    sortKey = '';

    rowsAmount = 12;

    sortOrder: number;
    sortField: string;
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    // @ViewChild('webshopItemDetails', {static: false}) webshopItemDetailsModal: WebshopItemDetailsModalComponent;
    dashboardPicture = AppConsts.appBaseUrl + '/assets/common/images/St.Regis option 1.jpg';

    responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 1,
            numScroll: 3
        },
        {
            breakpoint: '768px',
            numVisible: 2,
            numScroll: 2
        },
        {
            breakpoint: '560px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    //isFavoritesLoading = false;

    webshopCode: any;
    webshopTitle: any;
    typingTimer: any;
    doneTypingInterval = 500;
    showCarusel = false;

    globalProducts: BasketArticleDto[];

    primeng: PrimengTableHelper;

    constructor(
        injector: Injector,
        private webShopServiceProxy: WebShopServiceProxy,
        private _router: Router,
        private _webshopService: WebshopService,
        private _combineViewService: CombineViewService
    ) {
        super(injector);
    }
    //#endregion Getting data

    get isOGBannerAvailable(): boolean {
        return this._webshopService.isOGBannerAvailable;
    }

    get isBannerExists(): boolean {
        return this._webshopService.bannerExists;
    }

    get bannerName(): string {
        return this._webshopService.bannerName;
    }

    get orderGuide(): OrderGuideSimpleDto[] {
        return this._webshopService.orderGuides;
    }

    get isLoading(): boolean {
        return this._webshopService.isLoading;
    }

    get selectedOu(): any {
        return this._webshopService.selectedOu;
    }

    // get favoritesArticle(): BasketArticleDto[] {
    //     return this._webshopService.favoritesArticle;
    // }

    ngOnInit(): void {
        //reload Carousel list
        this.loadCarouselData();

        this._combineViewService.flush();

        if (this.orderGuide.length === 0) {
            this._webshopService.initPunchOut();
        }
        this.getCategories();

        if (this.isOuBlocked) {
            this.showIsBlockedMessage();
        } else {
            this.checkIsOuBlocked();
        }
    }

    toggleFavorites($event: Event, product: ArticleDto) {
        if (!product.favorite) {
            this._addToFavorite($event, product);
        } else {
            this._removeFromFavorite($event, product);
        }

        //reload list
        this.loadCarouselData();
    }

    // showFavorites() {
    //     this._webshopService.showFavorites();
    // }

    //
    // loadFavorites(event?: LazyLoadEvent) {
    //     this.isFavoritesLoading = true;
    //
    //     this._loadFavorites(event);
    // }

    // searchAndLoadFavorites(data: any) {
    //     let event = data.event || null;
    //
    //     this.webshopCode = data.webshopCode;
    //     this.webshopTitle = data.webshopTitle;
    //
    //     clearTimeout(this.typingTimer);
    //     this.typingTimer = setTimeout(this.loadFavorites.bind(this, event), this.doneTypingInterval);
    // }

    // private _loadFavorites(event?: LazyLoadEvent) {
    //     this.isFavoritesLoading = true;
    //
    //     this._webshopService.getFavorites$(this.webshopCode, event)
    //         .pipe(
    //             take(1),
    //             finalize(() => {
    //                 this.isFavoritesLoading = false;
    //             })
    //         ).subscribe();
    // }


    onSortChange(event) {
        let value = event.value;

        if (value.indexOf('!') === 0) {
            this.sortOrder = -1;
            this.sortField = value.substring(1, value.length);
        } else {
            this.sortOrder = 1;
            this.sortField = value;
        }
    }

    // openDetails(item: any) {
    //     event.stopPropagation();
    //     let article = (item.data ?? item) as ArticleDto;
    //     this.webShopServiceProxy.getArticle(
    //         article.id).subscribe();
    //
    //     this.webshopItemDetailsModal.show(item);
    // }

    openDetails(item: any) {
        abp.event.trigger('app.show.itemDetailModal', item);

        this.webshopService.updateArticleViewCounter(item);
    }

    navigatePunchOut(orderGuideId?: string): void {
        this._router.navigate(['/app/webshop/articles', orderGuideId]);
    }

    navigateCategory(categoryId?: string): void {
        this._router.navigate(['/app/webshop/categories', categoryId]);
    }

    getCategories() {
        this.isLoadingCategories = true;

        this.webShopServiceProxy.getCategoriesOverview()
            .subscribe((listResultDtoOfCategories: PagedResultDtoOfCategoryDto) => {
                this.categories = listResultDtoOfCategories.items;
                this.isLoadingCategories = false;

            }, (err) => {
                this.webShopServiceProxy.getCategoriesOverview()
                    .subscribe((listResultDtoOfCategories: PagedResultDtoOfCategoryDto) => {
                        this.categories = listResultDtoOfCategories.items;
                        this.isLoadingCategories = false;

                    }, (err) => {
                        return throwError(err);
                    });
            });
    }

    loadCarouselData(event?: LazyLoadEvent) {
        this.isLoadingArticles = true;
        this.webShopServiceProxy.getRelevantArticles(
            undefined,
            undefined
        )
            .pipe(finalize(() => this.showCarusel = true))
            .subscribe((result: PagedResultDtoOfArticleDto) => {
                this.products = result.items.map(x => this._getBasketArticles(x));
                this.products.forEach(x => x.quantity = 1);

                if (this.products.length >= 1) {
                    this.showCarusel = true;
                }

                this.isLoadingArticles = false;
            });
    }

    getData(event?: any) {
        this.webshopService.showLoader();

        let order = this.webshopService.getOrder(event);

        //set current page
        const page = event?.event?.page ?? 0;
        this._combineViewService.setCurrentPage(page);

        const skip = event?.event?.first ?? 0;
        const take = event?.event?.rows ?? this.rowsAmount;

        this._combineViewService.globalSearch$(
            this.webshopService.globalSearchFilter
            , undefined
            , order
            , skip
            , take
        )
        .pipe(
            finalize(() => {
                this.webshopService.hideLoader();
                this.spinnerService.hide();
            })
        )
        .subscribe((result: PagedResultDtoOfArticleDto) => {
            if (this.primeng) {
                this.primeng.totalRecordsCount = result.totalCount;
            } else {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
            }

            this.primengTableHelper.hideLoadingIndicator();
            this.spinnerService.hide();
        });
    }

    globalSearch(event?: any) {
        this.webshopService.showLoader();

        let order = this.webshopService.getOrder(event);

        const skip = event?.event?.first ?? 0;
        const take = event?.event?.rows ?? this.rowsAmount;

        this.webShopServiceProxy.getArticles(
            this.webshopService.globalSearchFilter,
            undefined,
            undefined,
            undefined,
            order,
            skip,
            take
        )
            .pipe(finalize(() => this.webshopService.hideLoader()))
            .subscribe((result: PagedResultDtoOfArticleDto) => {
                this.globalProducts = result.items.map(x => this._getBasketArticles(x));
                this.globalProducts.forEach(x => x.quantity = 1);

                if (this.primeng) {
                    this.primeng.totalRecordsCount = result.totalCount;
                } else {
                    this.primengTableHelper.totalRecordsCount = result.totalCount;
                }

                this.webshopService.hideLoader();
                this.primengTableHelper.hideLoadingIndicator();
            });
    }

    preventClick($event: Event) {
        $event.stopPropagation();
    }

    resetQuantity(article: BasketArticleDto) {
        article.quantity = 1;
    }

    addToBasket(article: BasketArticleDto) {
        this._addItemToBasket(article);
    }

    private _addToFavorite($event: Event, product: ArticleDto) {
        this.preventClick($event);

        this._webshopService.addToFavorite($event, product);
    }

    private _removeFromFavorite($event: Event, product: ArticleDto) {
        this.preventClick($event);

        this._webshopService.removeFromFavorite($event, product.id);
    }

    private _getBasketArticles(articleDto: ArticleDto): BasketArticleDto {
        const input: IBasketArticleDto = articleDto as BasketArticleDto;
        const data = new BasketArticleDto(input);

        return data;
    }

    private _addItemToBasket(article: BasketArticleDto) {
        if (+article.quantity <= 0 || article.quantity === undefined) {
            return throwError('Item quantity = 0, change ');
        }

        const item = _.cloneDeep(article);
        this._webshopService.addItem(item);
        this.resetQuantity(article);
    }

}

